export const OTHER_BUSINESS_TYPE = {
	label: 'Other',
	value: 'Other',
};

export const businessTypes = [
	{
		label: 'Technology',
		value: 'Technology',
	},
	{
		label: 'Finance',
		value: 'Finance',
	},
	{
		label: 'Healthcare',
		value: 'Healthcare',
	},
	{
		label: 'Retail',
		value: 'Retail',
	},
	{
		label: 'Manufacturing',
		value: 'Manufacturing',
	},
	{
		label: 'Education',
		value: 'Education',
	},
	{
		label: 'Hospitality',
		value: 'Hospitality',
	},
	{
		label: 'Logistics',
		value: 'Logistics',
	},
	{
		label: 'Government',
		value: 'Government',
	},
	OTHER_BUSINESS_TYPE,
];
